import script from "./ActivityList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityList.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityList.vue?vue&type=style&index=0&id=3256f62d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3256f62d"]])

export default __exports__